import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SettingList from './settings_list';
import SettingDetail from './settings_detail';

class Settings extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <SettingList/>;
    }else{
      if(params.id===undefined){
        view = <SettingDetail/>;
      }else{
        view = <SettingDetail action={params.action}/>;
      }
    }
    return (
      <div className="setting-page">{view}</div>
    );
  }
}

Settings.contextTypes = {
  router: PropTypes.object
};

export default Settings;
